import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';
var OpenMapTilesLanguage = require('./libraries/openmaptiles-language/openmaptiles-language');

;(function(jQuery){
    "use strict";
    function ProjectsAbroadMaps()
    {
        var global = {
            globalsInit: false,
            containerId: 'map-container',
            map: null,
            markerIconUrl: null,
            locations: false,
            language: null,
            styleUrl: null
        }

        var fn = {
            init: function() {
                jQuery(fn.setupGlobals);
                fn.renderMap();
                jQuery(window).on('paOpenSection', fn.renderMap);
            },

            setupGlobals: function() {
                if (typeof global.locations !== 'undefined') {
                    global.locations = window.productLocations;
                }
                global.markerIconUrl = '/base/images/cd-icon-location' + (navigator.userAgent.indexOf('Trident/7.0') !== -1 ? '.png' : '.svg' );
                global.language = jQuery('[data-map-lang]').attr('data-map-lang');
                global.styleUrl = jQuery('[data-map-style-url]').attr('data-map-style-url');
                global.globalsInit = true;
            },

            /**
             * Render the map
             *
             * The excecution order is optimised to reduce tile loads,
             * and so care should be taken when refactoring
             *
             * Calling fitBounds can be unreliable,
             * so we call it at multiple parts of the process
             */
            renderMap: function() {
                if (!global.globalsInit) {
                    // document.ready will not have run if this file loads after the ready event
                    fn.setupGlobals();
                }

                if (!global.locations) {
                    return;
                }

                OpenMapTilesLanguage(mapboxgl);

                var bounds = new mapboxgl.LngLatBounds();
                var markers = [];
                for (var i = 0; i < global.locations.length; i++) {
                    var location = global.locations[i];

                    var popup = new mapboxgl.Popup({offset: 50})
                        .setHTML(location.city)

                    var marker = new mapboxgl.Marker({element: fn.createPopupEl(), anchor: 'bottom'})
                        .setLngLat([location.longitude, location.latitude])
                        .setPopup(popup);

                    bounds.extend(marker.getLngLat());
                    markers.push(marker);
                }

                var fitBoundsOptions = fn.getFitBoundsOptions();
                var map = new mapboxgl.Map({
                    container: global.containerId,
                    scrollZoom: false,
                    bounds: bounds,
                    fitBoundsOptions: fitBoundsOptions
                }).addControl(new mapboxgl.NavigationControl({
                    showCompass: false
                }, 'top-left'));

                map.fitBounds(bounds, fitBoundsOptions);

                // Load style after the bounds are correctly set,
                // to avoid loading world-view tiles
                map.setStyle(global.styleUrl);

                map.setLanguage(global.language, true);

                markers.forEach(marker => {
                    marker.addTo(map);
                });

                map.on('load', function() {
                    map.fitBounds(bounds, fitBoundsOptions);
                });

                global.map = map;
            },

            getFitBoundsOptions: function() {
                var window = jQuery(document).width();
                if (window < 767) {
                    return {maxZoom:  5, padding: 50, animate: false};
                } else if (window < 1300) {
                    return {maxZoom: 9, padding: 150, animate: false};
                }
                return {maxZoom: 9, padding: 200, animate: false};
            },

            createPopupEl: function() {
                var el = document.createElement('div');
                el.className = 'marker';
                el.style.backgroundImage = 'url(' + global.markerIconUrl + ')';
                el.style.width = '48px';
                el.style.height = '48px';
                return el;
            }
        }

        fn.init();
    }
    new ProjectsAbroadMaps();
}($));